
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';


function Index({setShowHappy}) { 
     const {change} = useRefresh();
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);
     const [menus, setMenus] = useState([]);
    const [dishs, setdishs] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
    
    const [tequila, settequila] = useState(false);
  const [toptequila, settoptequila] = useState(false);
  const [aguardiente, setaguardiente] = useState(false);

  const [wine, setwine] = useState(false);

  const [whiskey, setwhiskey] = useState(false);

  const [mezcal, setmezcal] = useState(false);
  const [vodka, setvodka] = useState(false);
    const [cognac, setcognac] = useState(false);
    
     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
               
                setMenus(data);
            });
        }, [change]);
    
    
          useEffect(() => {
                menus.map((item) => {
                     if (item.id === 497) {
                        settequila(item);
                    }
                    if (item.id === 531) {
                        settoptequila(item);
                    }
                    if (item.id === 498) {
                        setaguardiente(item);
                    }

                    if (item.id === 499) {
                        setwine(item);
                    }

                    if (item.id === 502) {
                        setwhiskey(item);
                    }

                    if (item.id === 533) {
                        setmezcal(item);
                    }
                    if (item.id === 529) {
                        setvodka(item);
                    }
                    if (item.id === 532) {
                        setcognac(item);
                    }
                });
          }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px'}}>
                     
                     <img
                        src={require('./assets/screenbrunch.png')}
                        style={{
                        width: '100%',
                        height: 800,
                        objectFit: 'contain',
                        }}
                    />
                   
                </div>
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                
                {showListProduct && <ListProducts
                        dishs={dishs}
                        setShowListProduct={setShowListProduct}
                    />}
            </LayoutContent>
        </div>
    );
}
export default Index;